module.exports = __webpack_public_path__ + "static/media/SchoolCosHowItWorks3.efdee544.png";